<template>
  <div class="MainLayout">
    <!-- <div class="MainActions">
      <SearchBar />
      <StdButton icon="download">
        {{ DOWNLOAD_PDF }}
      </StdButton>
    </div> -->
    <div class="ChaptersSection">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { SearchBar, StdButton } from './../../components'
import { GENERAL } from './../../locales/es'
export default {
  components: {
    SearchBar,
    StdButton,
  },
  data() {
    return {
      ...GENERAL
    }
  },
}
</script>

<style scoped>
.MainLayout {
  margin: 0 auto;
  max-width: 790px;
  position: relative;
}

.MainActions {
  align-items: center;
  display: flex;
  height: 110px;
  justify-content: space-around;
}
</style>



// WEBPACK FOOTER //
// src/layouts/MainLayout/MainLayout.vue